var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw:relative tw:flex tw:flex-col tw:gap-1 tw:w-full tw:border tw:border-slate-100 tw:shadow-xs",attrs:{"role":"timer","aria-label":_vm.label || undefined,"aria-live":_setup.isExpired ? 'assertive' : 'off'}},[_c('div',{staticClass:"tw:flex tw:z-10 tw:px-4 tw:py-[2px] tw:items-center tw:justify-between tw:gap-2"},[(_vm.label)?_c('span',{class:[
                'tw:font-bold tw:tracking-wider tw:text-gray-950 tw:truncate',
                _setup.labelSizeClass,
            ]},[_vm._v("\n            "+_vm._s(_vm.label)+"\n        ")]):_vm._e(),_c('span',{class:[
                'tw:font-mono tw:font-bold tw:tabular-nums tw:shrink-0',
                _setup.isExpired
                    ? 'tw:text-red-600'
                    : _setup.urgente
                        ? 'tw:text-orange-500'
                        : 'tw:text-gray-950',
                _setup.sizeClass,
            ],attrs:{"aria-atomic":"true"}},[_vm._v("\n            "+_vm._s(_setup.isExpired ? _vm.expiryLabel : _setup.countdown.formatted.value)+"\n        ")])]),(_vm.showBar)?_c('div',{staticClass:"tw:absolute tw:left-0 tw:top-0 tw:w-full tw:h-full tw:rounded-sm tw:bg-white tw:overflow-hidden",attrs:{"aria-hidden":"true"}},[_c('div',{class:[
                'tw:h-full tw:rounded-sm tw:transition-all tw:duration-500',
                _setup.isExpired
                    ? 'tw:bg-red-500'
                    : _setup.urgente
                        ? 'tw:bg-orange-400'
                        : 'tw:bg-green-400',
            ],style:({ width: _setup.isExpired ? '0%' : `${_setup.countdown.percentLeft.value}%` })})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }